(function(){
  function init(root){
    if(!root||root.dataset.rchReady==='true')return;
    root.dataset.rchReady='true';
    root.querySelectorAll('[data-rch-tab]').forEach(function(tab){
      tab.addEventListener('click',function(){
        var group=tab.closest('[data-rch-tabs]');
        if(!group)return;
        group.querySelectorAll('[data-rch-tab]').forEach(function(item){item.setAttribute('aria-selected','false')});
        group.querySelectorAll('[data-rch-panel]').forEach(function(panel){panel.hidden=true});
        tab.setAttribute('aria-selected','true');
        var panel=group.querySelector('#'+tab.getAttribute('aria-controls'));
        if(panel)panel.hidden=false;
      });
    });
    root.querySelectorAll('[data-rch-faq-button]').forEach(function(button){
      button.addEventListener('click',function(){
        var answer=button.nextElementSibling,expanded=button.getAttribute('aria-expanded')==='true';
        button.setAttribute('aria-expanded',String(!expanded));
        var symbol=button.querySelector('.rch-faq-symbol');if(symbol)symbol.textContent=expanded?'+':'−';
        if(answer)answer.hidden=expanded;
      });
    });
  }
  function initAll(scope){(scope||document).querySelectorAll('.rch-page').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document)});else initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target)});
})();
